import dynamic from 'next/dynamic';
import cx from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import Link from 'next/link';
import { useRouter } from 'next/router';

import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';

const Typography = dynamic(() => import('../../atoms/typography/typography'));
const Button = dynamic(() => import('../../molecules/button/button'));

const Card = ({
  tooltip,
  card_type, // small || normal
  thumbnail,
  name,
  call_out,
  duration,
  ages,
  sessions,
  slug
}) => {
  const router = useRouter();
  const { isMobile, isDesktop } = useWindowSize();
  const agesMinMax = ages && ages.split(' a ');
  return (
    <Link href={`/cursos/${slug}`}>
      <div
        className={cx(styles.card, {
          [styles.card__normal]: card_type === 'normal',
          [styles.card__small]: card_type === 'small'
        })}
      >
        {/* Tooltip */}
        {tooltip && (
          <div className={styles.tooltip}>
            <Typography
              fontSize={[12, 12]}
              lineHeight={[14, 14]}
              fontWeight={700}
              color="#FFFFFF"
              tag="p"
            >
              {tooltip}
            </Typography>
          </div>
        )}

        {/* Image */}
        <div className={styles.image}>
          <LazyLoadImage
            width="100%"
            height="100%"
            effect="blur"
            alt={`${name}`}
            src={thumbnail}
            placeholder={<Skeleton width="100%" height="100%" />}
          />
        </div>

        {/* Container */}
        <div className={styles.container}>
          {/* Information */}
          <div className={styles.information}>
            <div className={styles.title}>
              <a href={`/cursos/${slug}`}>
                <Typography
                  fontSize={card_type === 'normal' ? [24, 24] : [24, 16]}
                  lineHeight={card_type === 'normal' ? [26, 26] : [26, 18]}
                  fontWeight={700}
                  tag="h3"
                >
                  {name && name.replace(/Paquete: |Paquete 1: |Paquete 2: /, '')}
                </Typography>
              </a>
            </div>

            {duration && sessions && (
              <div className={styles.subtitle}>
                <Typography fontSize={[14, 12]} lineHeight={[24, 16]} tag="p">
                  {duration} meses - {sessions} clases
                </Typography>
              </div>
            )}
          </div>

          {/* Description */}
          <div className={styles.description}>
            {ages && (!isMobile || card_type === 'normal') && (
              <div className={styles.age}>
                <Typography
                  fontSize={[14, 12]}
                  lineHeight={[24, 16]}
                  fontWeight={700}
                  tag="p"
                >
                  {agesMinMax[0]} a {agesMinMax[1]} años
                </Typography>
              </div>
            )}

            <div className={styles.text}>
              <Typography fontSize={[14, 14]} lineHeight={[18, 16]} tag="p">
                {call_out}
              </Typography>
            </div>

            {isDesktop && (
              <div className={styles.button}>
                <Button
                  variant="black"
                  buttonType="button"
                  onClick={() => router.push(`/cursos/${slug}`)}
                  width="100%"
                  height={isMobile ? '45px' : '48px'}
                  textOptions={{
                    fontSize: [20, 16],
                    lineHeight: [21, 18],
                    fontWeight: 700,
                    color: 'white'
                  }}
                >
                  Ver el curso
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card;
